import React, { Component } from 'react';
import { FormSpy } from 'react-final-form';
import { Link } from '../../api';

class PreloadUniqueSlug extends Component {
  componentWillMount() {
    const { values, form } = this.props
    
    if (!form)
      return
    if ( !values || (!values.unique_slug && !values.slug && !values.id)  ) {
      Link.randomSlug().then( (res)=>{
        form.change('unique_slug', res.unique_slug)
        form.change('unique_slug_hash', res.unique_slug_hash)
      });
    }
  }
  
  render() {
    return null
  }
}

// Make a HOC
export default props => (
  <FormSpy
    {...props}
    subscription={{ active: true, values: true }}
    component={PreloadUniqueSlug}
  />
)


// WEBPACK FOOTER //
// ./src/components/Links/PreloadUniqueSlug.js